import {
  SelectItem,
  useColdLocationOptionsQuery,
} from '@kistill/client/data-access'
import { Grid, TextFieldProps } from '@mui/material'
import { AutocompleteElement } from 'react-hook-form-mui'

interface ColdLocationSelectorProps {
  name: string
  label: string
  inputProps?: TextFieldProps
  itemTypeGuid: string | undefined
}

export function KistillColdLocationSelector({
  name,
  label,
  itemTypeGuid,
}: ColdLocationSelectorProps) {
  const { data } = useColdLocationOptionsQuery({
    variables: {
      itemTypeGuid: itemTypeGuid ? itemTypeGuid : '',
    },
    fetchPolicy: 'network-only',
  })

  const coldLocationOptions = data?.coldLocationOptions?.map((x) => {
    return { id: x.id, label: x.title } as unknown as SelectItem
  })

  return (
    <Grid item container alignItems='center'>
      <Grid item xs={12}>
        <AutocompleteElement
          multiple
          name={`${name}`}
          label={label}
          options={coldLocationOptions || []}
        />
      </Grid>
    </Grid>
  )
}
